// components/GameBanners.vue
<script setup>
defineOptions({ name: 'GameBanners' });

import { computed } from 'vue';
import { useBannersStore } from '../stores/banners/bannersStore';
import { useCategoriesStore } from '../stores/categories/categoriesStore';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

const bannersStore = useBannersStore();
const categoriesStore = useCategoriesStore();

defineProps({
  type: {
    type: String,
    required: true,
    validator: (value) => ['banners', 'news'].includes(value)
  }
});

// Computed
const news = computed(() => bannersStore.banners.news);
const allActiveBanners = computed(() => {
  const { desktop, mini } = bannersStore.getActiveBanners;
  let banners = [];
  
  if (desktop?.regular?.length) banners.push(...desktop.regular);
  //if (mobile?.regular?.length) banners.push(...mobile.regular);
  if (mini?.regular?.length) banners.push(...mini.regular);
  
  return banners;
});

const handleBannerClick = (event, banner) => {
  event.preventDefault();
  
  if (banner.url.startsWith('http')) {
    window.open(banner.url, '_blank');
    return;
  }

  // Si es una categoría, usar directamente el store
  if (banner.urlType === 'category') {
    categoriesStore.setSelectedCategory(banner.url);
  }
};
</script>

<template>
  <!-- News Banner -->
  <div v-if="type === 'news' && news?.active && news?.message" class="news-banner">
    <div class="news-content">
      <span class="news-text">{{ news.message }}</span>
    </div>
  </div>

  <!-- Banners Carousel -->
  <div v-if="type === 'banners' && allActiveBanners.length > 0" class="banners-section">
    <swiper
      :modules="[Autoplay, Pagination]"
      :slides-per-view="1"
      :space-between="10"
      :autoplay="{ delay: 3000, disableOnInteraction: false }"
      :pagination="{ clickable: true }"
      :breakpoints="{
        640: { slidesPerView: Math.min(2, allActiveBanners.length) },
        1024: { slidesPerView: Math.min(3, allActiveBanners.length) }
      }"
      class="banner-swiper"
    >
      <swiper-slide v-for="banner in allActiveBanners" :key="banner.image">
        <a 
          href="#"
          class="banner-link"
          @click="(event) => handleBannerClick(event, banner)"
        >
          <img :src="banner.image" :alt="banner.url" class="banner-image">
        </a>
      </swiper-slide>
    </swiper>
  </div>
</template>

<style scoped>
@import '../assets/styles/main.css';
</style>